import CultureBase from './culture-base.vue'
import ListCulture from './list-culture.vue'
export default {
  path: '/culture',
  meta: {
    nav: {
      icon: 'blur_circular',
      childDefault: true
    },
    breadCrumb: 'Culture'
  },
  component: CultureBase,
  children: [
    {
      path: '',
      name: 'culture',
      meta: {
        breadCrumb: 'List'
      },
      component: ListCulture
    }
  ]
}
